import { getValueByPath } from 'utils-lib/dist/object';
import { findParentComponent } from '../utils/helper';

export default {
  props: {
    size: String,
  },
  computed: {
    // 父级表单
    parentForm() {
      return findParentComponent(this, 'hive-form');
    },

    // 尺寸
    curSize() {
      return this.size || getValueByPath(this.parentForm, 'size');
    },
  },
};
